import styled from "styled-components";

import {
  DefaultParagraphLargeFactory,
  DefaultTitleMediumFactory,
} from "../../../../components/Habitacional/core/Typograph/Typograph.Style";

export const LibrasAssistanceSectionContainer = styled.section(({ theme }) => ({
  paddingTop: "40px",
  paddingBottom: "40px",
  marginBottom: "0 !important",
  backgroundColor: `${theme.color.neutral["07"]} !important`,

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    paddingBottom: "60px",
    gap: "40px",
  },

  svg: {
    color: theme.color.brandPrimary.light,
  },
}));

export const LibrasAssistanceSectionContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "60px",

  [theme.breakpoint.lg()]: {
    flexDirection: "row",
    alignItems: "initial",
  },
}));

export const LibrasAssistanceSectionBlock = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "initial",
  gap: "32px",

  [theme.breakpoint.lg()]: {
    alignItems: "flex-start",
  },
}));

export const LibrasAssistanceSectionBlockHeader = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
}));

export const LibrasAssistanceSectionBlockTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleMediumFactory({ theme }),
}));

export const LibrasAssistanceSectionBlockDescription = styled.p(
  ({ theme }) => ({
    ...DefaultParagraphLargeFactory({ theme }),

    strong: {
      ...DefaultParagraphLargeFactory({ theme }),
    },
  })
);
